"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueAnim = exports.rogueCursor = void 0;
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueAanimManager_sidecar_1 = require("./rogueAanimManager-sidecar");
var key = 'destroy-house';
// export const getSpellStats = () => {
//   return rogueSpellData.getSpellStats(key)
// }
// export function getSpellData(): IRogueSpellData {
//   return {}
// }
function rogueCursor(gridX, gridY, activate) {
    if (activate) {
        rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueAnim());
    }
}
exports.rogueCursor = rogueCursor;
function rogueAnim() {
    var delay, map, tiles, j, i, t, i, t, colors, m;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                delay = 0.01;
                return [4 /*yield*/, { delay: delay }];
            case 1:
                _a.sent();
                map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
                tiles = [];
                for (j = 0; j < map.h; j++) {
                    for (i = 0; i < map.w; i++) {
                        t = rogueMaps_sidecar_1.rogueMaps.getTile(map, i, j);
                        if (t) {
                            if (t.eTile === rogueMaps_1.ETile.Wall ||
                                t.eTile === rogueMaps_1.ETile.WallDamaged ||
                                t.eTile === rogueMaps_1.ETile.Floor) {
                                tiles.push(t);
                            }
                            if (t.eTile === rogueMaps_1.ETile.Window ||
                                t.eTile === rogueMaps_1.ETile.Door ||
                                t.eTile === rogueMaps_1.ETile.DoorOpen) {
                                tiles.push(t);
                            }
                        }
                    }
                }
                tiles = rando_sidecar_1.rando.shuffle(tiles);
                i = 0;
                _a.label = 2;
            case 2:
                if (!(i < tiles.length)) return [3 /*break*/, 5];
                t = tiles[i];
                colors = [
                    rogueDef_sidecar_1.rogueDef.colors.dark,
                    rogueDef_sidecar_1.rogueDef.colors.darkBlue,
                    rogueDef_sidecar_1.rogueDef.colors.brown,
                    rogueDef_sidecar_1.rogueDef.colors.blueGray,
                ];
                rogueGlyphs_sidecar_1.rogueGlyphs.write(t.x, t.y, '*', rando_sidecar_1.rando.sample(colors), 2);
                rogueMaps_sidecar_1.rogueMaps.setTile(map, t.x, t.y, rogueMaps_1.ETile.WallBroken, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.blueGray);
                m = rogueMonsters_sidecar_1.rogueMonsters.getAt(t.x, t.y);
                if (m) {
                    rogueMonsters_sidecar_1.rogueMonsters.damage(m, 10, 'cut');
                }
                rogueMaps_sidecar_1.rogueMaps.setVisibility(map, t.x, t.y, rogueMaps_1.EVision.WasSeen);
                return [4 /*yield*/, { delay: delay }];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 2];
            case 5:
                rogueRunner_sidecar_1.rogueRunner.setPlayerUsedTurn();
                return [2 /*return*/];
        }
    });
}
exports.rogueAnim = rogueAnim;
